export const campaignMediaDemographicStatsUrl =
  "/api/v3/campaign/:id/demographic_statistics";

export const downloadCampaignGraphPdfReportUrl =
  "/api/v3/campaign/:id/city/:cityId/graph/export/pdf";
